// Copyright (c) 2017 Deere & Company

import {buildClaimRoutes} from '../../../shared/services/build-claim-route';
import {routerActions} from 'react-router-redux';

export const handleSearchAction = (claim, action) =>
    dispatch => {

        const claimRoute = action.id === 'APLYPIP' ?
            '/claims/pip/new' :
            `${buildClaimRoutes(claim.claimType.key, claim.subClaimType.key, claim.claimNumber)}?action=${action.id}`;

        dispatch(routerActions.push(claimRoute));

    };



// WEBPACK FOOTER //
// ./src/claim/claim-search/action-creators/handle-search-action.js